import CardPhotoElementConfiguration from './CardPhotoElementConfiguration';

export default CardPhotoElementConfiguration;
